export default "/assets/a62fa4754fc44b28.svg"